import type { FunctionComponent } from 'react';

import { useGetResources } from '@hooks/useGetResources';

import Modal from '@helsenorge/designsystem-react/components/Modal';

interface AvvisOppgaveConfirmationProps {
  onConfirm: () => void;
  onClose: () => void;
}

const AvvisOppgaveConfirmationModal: FunctionComponent<AvvisOppgaveConfirmationProps> = ({
  onConfirm,
  onClose,
}: AvvisOppgaveConfirmationProps) => {
  const resources = useGetResources();

  return (
    <Modal
      testId="avvis-oppgave-confirmation-modal"
      title={resources?.modal_svarEnroll_tittel || ''}
      description={resources?.modal_enroll_nei_tekst}
      primaryButtonText={resources?.modal_knapp_sikker}
      secondaryButtonText={resources?.confirmBoxAvbryt}
      size={'medium'}
      onSuccess={onConfirm}
      onClose={onClose}
    ></Modal>
  );
};

export default AvvisOppgaveConfirmationModal;
